var map = {
	"./img/_page/1.png": "fd85",
	"./img/_page/2.png": "ec9b",
	"./img/_page/3.png": "91d9",
	"./img/_page/4.png": "67e7",
	"./img/aboutus/anna_k.jpg": "d3d5",
	"./img/aboutus/gena_s.jpg": "f16f",
	"./img/aboutus/girl-qstand.jpg": "4c29",
	"./img/aboutus/groupoffice.jpg": "565b",
	"./img/aboutus/making-happy.jpg": "4055",
	"./img/aboutus/mykola_s.jpg": "bf35",
	"./img/aboutus/sandra_s.jpg": "edff",
	"./img/aboutus/team.jpg": "37b6",
	"./img/aboutus/tom_v.jpg": "966a",
	"./img/aboutus/workbench.jpg": "d5c3",
	"./img/campaign/writeqs.jpg": "12a8",
	"./img/career/team.jpg": "6da4",
	"./img/carousel/mutual-care.jpg": "d155",
	"./img/carousel/puck_workflow.svg": "2fae",
	"./img/carousel/safe-connected.jpg": "ccfa",
	"./img/carousel/seniors-alone.jpg": "2a89",
	"./img/carousel/unexpected-moments.jpg": "38a3",
	"./img/landing/Kickstarter-page-800x650.png": "30b1",
	"./img/landing/Screenshot from 2018-11-05 13-35-24.png": "1469",
	"./img/landing/top-people-tr.png": "1c69",
	"./img/logo/Lorinthe-Icon-grey.svg": "c665",
	"./img/logo/Lorinthe-Icon.svg": "7ba1",
	"./img/logo/Lorinthe-Logo-semi-transparant.svg": "07b8",
	"./img/logo/Lorinthe-Logo-white.svg": "567d",
	"./img/logo/Lorinthe-Logo.svg": "81df",
	"./img/logo/Q-white.svg": "0c82",
	"./img/logo/Qrespi-Icon-semi-transparant.svg": "5c9e",
	"./img/logo/Qrespi-Logo-m.svg": "9f43",
	"./img/logo/Qrespi-Logo.png": "442b",
	"./img/logo/Qrespi-Logo.svg": "40fd",
	"./img/logo/Qrespi-icon.svg": "025a",
	"./img/logo/Qrespi-logo-white.svg": "75ac",
	"./img/preorder/Q-bee-mailing.svg": "6eb8",
	"./img/preorder/bathroom-puck-blue.jpg": "9bbf",
	"./img/preorder/puck-red-s.png": "28b8",
	"./img/preorder/puck-red.png": "b3e0",
	"./img/prices/consult.jpg": "78f1",
	"./img/prices/four-pucks.png": "a594",
	"./img/prices/one-puck.png": "0983",
	"./img/prices/two-pucks.png": "12b4",
	"./img/puck/puck-chat.jpg": "70e7",
	"./img/puck/puck-dimensions-v01.png": "8b5d",
	"./img/puck/puck-exploded-view-v01.png": "0271",
	"./img/resources/Q-bee-faq.svg": "b0fe",
	"./img/resources/confused.jpg": "92cb",
	"./img/resources/faq-senior.jpg": "fed5",
	"./img/resources/leaflet.png": "8960",
	"./img/resources/quickstart.png": "a923",
	"./img/seals/fbm.svg": "a576",
	"./img/seals/slack.svg": "3c7f",
	"./img/seals/telegram.svg": "017a",
	"./img/seals/wa.svg": "d22a",
	"./img/services/Q-bee-02.svg": "fa60",
	"./img/services/alert-chat.svg": "5b39",
	"./img/services/alert.png": "365e",
	"./img/services/automated-test.svg": "a19a",
	"./img/services/check-in-out.svg": "5b25",
	"./img/services/follow-up.svg": "80af",
	"./img/services/heartbeat.svg": "52d2",
	"./img/services/robot-call.svg": "e949",
	"./img/services/setup.png": "804e",
	"./img/services/sound-effects.svg": "d54e",
	"./img/services/telegram-alert.png": "2cca",
	"./img/services/whatsapp-alert.png": "fe5f",
	"./img/solutions/b2b.jpg": "0257",
	"./img/solutions/b2c-qbee.jpg": "ff30",
	"./img/solutions/b2c.jpg": "d8e7",
	"./img/solutions/bathroom-full.jpg": "d900",
	"./img/solutions/bathroom-m.jpg": "8309",
	"./img/solutions/bathroom.jpg": "db2d",
	"./img/solutions/bedroom-m.jpg": "69f1",
	"./img/solutions/bedroom.jpg": "b849",
	"./img/solutions/bedroom_full.jpg": "0043",
	"./img/solutions/frontdoor-full.jpg": "88e2",
	"./img/solutions/frontdoor-m.jpg": "4e47",
	"./img/solutions/frontdoor.jpg": "2f13",
	"./img/solutions/garden-full.jpg": "ac44",
	"./img/solutions/garden-m.jpg": "7b47",
	"./img/solutions/garden.jpg": "b2c1",
	"./img/solutions/kitchen-full.jpg": "50b7",
	"./img/solutions/kitchen-m.jpg": "341e",
	"./img/solutions/kitchen.jpg": "bbfb",
	"./img/solutions/oem-yacht.jpg": "29b5",
	"./img/technology/3d-printer.jpg": "4a39",
	"./img/technology/choices.jpg": "b48e",
	"./img/technology/elec-lab.jpg": "111e",
	"./img/technology/injection-molding.jpg": "5175",
	"./img/technology/node.svg": "0e5d",
	"./img/technology/puck-explode.png": "f0ff",
	"./img/technology/qrespi-workflow.svg": "de32",
	"./img/technology/scrum_process.svg": "52fa",
	"./img/technology/state-management.svg": "a416",
	"./img/technology/ubuntu.svg": "90ad",
	"./img/technology/ufollowus-workflow.svg": "830f",
	"./img/technology/vuejs.svg": "bf8b",
	"./img/upgrade/upgrade-site.jpg": "c200",
	"./img/workflow/puck_workflow.svg": "06aa",
	"./video/Puck-by-Qrespi-Introduction-v22.de.vtt": "d050",
	"./video/Puck-by-Qrespi-Introduction-v22.en.vtt": "e13e",
	"./video/Puck-by-Qrespi-Introduction-v22.mp4": "9a27",
	"./video/Puck-by-Qrespi-Introduction-v22.nl.vtt": "a382",
	"./video/Puck-by-Qrespi-Introduction-v22.webm": "e781",
	"./video/PuckbyQrespi-poster-m.jpg": "0e71",
	"./video/PuckbyQrespi-poster.jpg": "1a8a",
	"./video/PuckbyQrespi-poster_bg-m.jpg": "5f58",
	"./video/PuckbyQrespi-poster_bg.jpg": "d201"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2381";